// TODO: UPGRADEAR A CAPACITOR 3 CUANDO SEAMOS MILLONARIOS
//import AnyBridgeDroid from 'src/capacitorPlugin';
//import {Capacitor} from "@capacitor/core";
//import API from "src/core/Api";

// Other codes...
import { Plugins, Capacitor, Device } from '@capacitor/core';
const { TopWisezPlugin, App } = Plugins;

export default class AndroidBridge {

    appEnabled() {
        return (Capacitor.getPlatform() === 'android'  && Capacitor.isPluginAvailable('TopWisezPlugin'));
    }

    enablePressBackToOut(url) {
        console.log('******** enablePressBackToOut *********');
        if (url) {
            App.removeAllListeners();
            App.addListener('backButton', (data) => {
                console.log('******** Back button pressed *********');
                url = url.replace(/^\/|\/$/g, '');
                let location = window.location.href;
                location = location.replace(/^\/|\/$/g, '');

                if (location === url) {
                    if (confirm("¿Desea salir de la aplicación?")) {
                        App.exitApp();
                    }
                }
                else {
                    window.history.back();
                }
            });
        }
    }

    async DeviceLoad() {
        if (this.appEnabled()) {
            console.log('******** DeviceLoad *********');
            TopWisezPlugin.DeviceLoad();
        }
    }

    async VisanetPayApp(amount, audit, visacoutas) {
        if (this.appEnabled()) {
            console.log('******** VisanetPayApp *********');
            console.log('******** AUDIT:  *********' + audit);
            console.log('******** AMOUNT:  *********' + amount);
            TopWisezPlugin.VisanetPayApp({amount: amount, audit: audit, visacoutas: visacoutas});
        }
    }

    async VisanetPayAppAnular(amount, audit) {
        if (this.appEnabled()) {
            console.log('******** VisanetPayAppAnular *********');
            console.log('******** AUDIT:  *********' + audit);
            console.log('******** AMOUNT:  *********' + amount);
            TopWisezPlugin.VisanetPayAppAnular({amount: amount, audit: audit});
        }
    }

    async VisanetPayAppCierre() {
        if (this.appEnabled()) {
            console.log('******** VisanetPayAppCierre *********');
            TopWisezPlugin.VisanetPayAppCierre();
        }
    }

    async CardReaderStart() {
        if (this.appEnabled()) {
            console.log('******** CardReaderStart *********');
            TopWisezPlugin.CardReaderStart();
        }
    }

    async CardReaderStop() {
        if (this.appEnabled()) {
            console.log('******** CARD CardReaderStop *********');
            TopWisezPlugin.CardReaderStop();
        }
    }

    async PrintFactura(data) {
        if (this.appEnabled()) {
            console.log('******** CardReaderStop *********');
            TopWisezPlugin.PrintFactura({data: data});
        }
    }

    async PrintRecibo(data) {
        if (this.appEnabled()) {
            console.log('******** PrintRecibo *********');
            TopWisezPlugin.PrintRecibo({data: data});
        }
    }

    async PrintVoucher(data) {
        if (this.appEnabled()) {
            console.log('******** PrintVoucher *********');
            TopWisezPlugin.PrintVoucher({data: data});
        }
    }
}
